var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-modal',{attrs:{"id":"modal_reservaInfo","size":"lg","title":_vm.titulo,"hide-header":"","ok-only":"","content-class":"shadow","button-size":"sm","centered":"","ok-title":"Cerrar","ok-variant":"outline-primary"}},[_c('reservaInfo')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }